﻿export const getAdditionalApproverIds = (approvers) => {
  if (!approvers) return [];

  return approvers
    .filter((approver) => !approver.regionId)
    .map((approver) => approver.assignedUsers?.map((user) => user.userId))
    .flat()
    .filter((id) => !!id);
};
